import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import {
  getMonitorParts,
  getMonitor,
  getAccessorySequence,
  getAccessoryChoices,
  getFilterChoices,
} from "redux/reducers";
import { PartsCollection } from "models/Part";

import $api from "api";

import FilterSequence from "./FilterSequence";
import AccessorySequence from "./AccessorySequence";
import ManageOrder from "./ManageOrder";

import "./Configurator.css";
import { CHANGE_ACCESSORY_CHOICES, CHANGE_FILTER_CHOICES } from "redux/actions";

class Configurator extends Component {
  componentDidMount() {
    // record activity
    $api.postActivity(`configurator/${this.props.monitorId}`);
  }

  onFilterChoicesChanged = (newFilterChoices) => {
    const { accessoryChoices, changeAccessoryChoices, changeFilterChoices } =
      this.props;

    // if all filters chosen, setup the accessory choices
    const numFiltersChosen = Array.from(newFilterChoices.values()).reduce(
      (acc, filterChoice) =>
        acc + (filterChoice.choice !== "" || filterChoice.skip ? 1 : 0),
      0,
    );
    if (numFiltersChosen === newFilterChoices.size && !accessoryChoices) {
      // need to create the accessoryChoices
      const { monitor, partsCollection } = this.props;
      const newAccessoryChoices = new Map();
      // moving now to accessories...
      // ... setup sequence of drop-downs, ie. accessory -> extension-cable -> leadset
      // find out which accessory to show in first drop down
      getAccessorySequence(monitor, newFilterChoices, true).forEach(
        (component, idx, arr) => {
          newAccessoryChoices.set(component.type, {
            choice: [], // an array of Part objects or non-part strings like 'no-extension-cable'
            includedParts: [], // an array of parts that go along with part(s) in choice
            flex: component.flex || 1,
            parameterOptionFilter: component.filter || "", // only used in M540 / ECG / 12-lead
            solved: false,
            prevId: idx > 0 ? arr[idx - 1].type : null,
            nextId: idx + 1 < arr.length ? arr[idx + 1].type : null,
          });
        },
      );
      // reset scratch data on remaining parts
      partsCollection.resetParts();

      // let AcessorySequence solve for its own choices
      changeAccessoryChoices(newAccessoryChoices);
    } else if (numFiltersChosen < newFilterChoices.size && accessoryChoices) {
      changeAccessoryChoices(null);
    }

    // console.log('onFilterChoicesChanged', newFilterChoices);
    changeFilterChoices(newFilterChoices);
  };

  onAccessoryChoicesChanged = (newAccessoryChoices) => {
    console.log("onAccessoryChoicesChanged", newAccessoryChoices);
    const { changeAccessoryChoices } = this.props;
    changeAccessoryChoices(newAccessoryChoices);
  };

  renderManageOrder() {
    const { accessoryChoices } = this.props;
    if (!accessoryChoices) {
      return null;
    }
    const allAccessoriesChoices = Array.from(accessoryChoices.values()).filter(
      (accessoryChoice) => accessoryChoice.choice.length > 0,
    );
    if (allAccessoriesChoices.length === accessoryChoices.size) {
      return (
        <ManageOrder
          partsList={allAccessoriesChoices.reduce(
            (acc, choice) => [...acc, ...choice.includedParts],
            [],
          )}
        />
      );
    }
    return null;
  }

  render() {
    const { filterChoices, accessoryChoices } = this.props;

    return (
      <div className="Configurator">
        <FilterSequence
          {...this.props}
          filterChoices={filterChoices}
          onFilterChoicesChanged={this.onFilterChoicesChanged}
        />
        <AccessorySequence
          {...this.props}
          filterChoices={filterChoices}
          accessoryChoices={accessoryChoices}
          onAccessoryChoicesChanged={this.onAccessoryChoicesChanged}
        />
        {this.renderManageOrder()}
      </div>
    );
  }
}

Configurator.defaultProps = {
  accessoryChoices: null,
  filterChoices: null,
};
Configurator.propTypes = {
  monitorId: PropTypes.string.isRequired,
  monitor: PropTypes.shape().isRequired,
  partsCollection: PropTypes.instanceOf(PartsCollection).isRequired,
  changeAccessoryChoices: PropTypes.func.isRequired,
  changeFilterChoices: PropTypes.func.isRequired,
  accessoryChoices: PropTypes.instanceOf(Map),
  filterChoices: PropTypes.instanceOf(Map),
};

export default connect(
  (state, props) => {
    const { monitorId } = props;
    return {
      monitor: getMonitor(state, monitorId),
      partsCollection: getMonitorParts(state, monitorId),
      accessoryChoices: getAccessoryChoices(state),
      filterChoices: getFilterChoices(state),
    };
  },
  (dispatch) => ({
    changeAccessoryChoices: (newAccessoryChoices) =>
      dispatch({ type: CHANGE_ACCESSORY_CHOICES, newAccessoryChoices }),
    changeFilterChoices: (newFilterChoices) =>
      dispatch({ type: CHANGE_FILTER_CHOICES, newFilterChoices }),
  }),
)(Configurator);
